import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { OrderingParty } from '../../models/OrderingParty';
import { OrderingPartyService } from '../../service/ordering-party.service';

@Component({
  selector: 'app-ordering-party-info',
  templateUrl: './ordering-party-info.component.html',
  styleUrls: ['./ordering-party-info.component.scss']
})
export class OrderingPartyInfoComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef, private orderingPartyService: OrderingPartyService) {
    super(dialog);
  }

  @Input() orderingPartyId: number;

  orderingParty: OrderingParty;
  orderingPartyInfoHtml = '';
  isLoading = false;

  ngOnInit(): void {
    this.isLoading = true;

    this.orderingPartyService.getOrderingParty(this.orderingPartyId).subscribe({
      next: (r) => {
        this.orderingParty = r;
        this.orderingPartyInfoHtml = r.info?.replace(/\r?\n/g, '<br/>') ?? '';
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  close(): void {
    this.dialog.close();
  }

}
